"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrequencyRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.FrequencyRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.frequency.label',
    fallbackLabel: 'Frequency',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'DAILY', label: 'fields.enm.frequency.options.DAILY', fallbackLabel: 'Live / daily' },
        { key: 'WEEKLY', label: 'fields.enm.frequency.options.WEEKLY', fallbackLabel: 'Weekly' },
        { key: 'MONTHLY', label: 'fields.enm.frequency.options.MONTHLY', fallbackLabel: 'Monthly' },
        { key: 'OTHER', label: 'fields.enm.frequency.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
